import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { Card, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import MainContainer from "theme/MainConatiner";
import RestaurantPhotos from "../profile/components/RestaurantPhotos";
import HeaderTilteBar from "components/TitleBar/HeaderTilteBar";
import ManagePhotosSkeleton from "./ManagePhotosSkeleton";
import "./style.css";

const ManagePhotosContainer = memo(
    ({
        foodPhotos,
        ambiancePhotos,
        onAddResPhoto,
        onDeleteResPhoto,
        restaurantName,
        isLoading,
    }) => {
        const theme = useTheme();
        const [activeTab, setActiveTab] = useState("food");

        const handleTabChange = (event, newValue) => {
            if (newValue !== null) setActiveTab(newValue);
        };

        const tabToggle = (
            <ToggleButtonGroup
                value={activeTab}
                exclusive
                onChange={handleTabChange}
                sx={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: 2,
                    p: 0.5,
                    border: "none",
                    "& .MuiToggleButtonGroup-grouped": {
                        border: "none",
                        "&:not(:first-of-type)": { borderRadius: 2 },
                        "&:first-of-type": { borderRadius: 2 },
                    },
                }}
            >
                <ToggleButton
                    value="food"
                    sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        px: 3,
                        py: 0.5,
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#666",
                        "&.Mui-selected": {
                            backgroundColor: "#fff",
                            color: theme.palette.typographyLabel?.main || "#000",
                            boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
                            "&:hover": { backgroundColor: "#fff" },
                        },
                    }}
                >
                    🍽️ Food
                </ToggleButton>
                <ToggleButton
                    value="ambience"
                    sx={{
                        textTransform: "none",
                        borderRadius: 2,
                        px: 3,
                        py: 0.5,
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#666",
                        "&.Mui-selected": {
                            backgroundColor: "#fff",
                            color: theme.palette.typographyLabel?.main || "#000",
                            boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
                            "&:hover": { backgroundColor: "#fff" },
                        },
                    }}
                >
                    ✨ Ambience
                </ToggleButton>
            </ToggleButtonGroup>
        );

        return (
            <MainContainer>
                <Card className="manage-photos-card-container">
                    {isLoading ? (
                        <ManagePhotosSkeleton />
                    ) : (
                        <>
                            <HeaderTilteBar
                                title={"Manage Photos"}
                                isSearch={false}
                                isAddVisible={true}
                                btnText={"Add Photos"}
                                handleAddBtn={() => onAddResPhoto(activeTab)}
                                rightContent={tabToggle}
                            />

                            <RestaurantPhotos
                                foodPhotos={foodPhotos}
                                ambiancePhotos={ambiancePhotos}
                                onAddClick={onAddResPhoto}
                                onDeleteClick={onDeleteResPhoto}
                                activeTab={activeTab}
                                onTabChange={handleTabChange}
                            />
                        </>
                    )}
                </Card>
            </MainContainer>
        );
    }
);

ManagePhotosContainer.propTypes = {
    foodPhotos: PropTypes.array,
    ambiancePhotos: PropTypes.array,
    onAddResPhoto: PropTypes.func,
    onDeleteResPhoto: PropTypes.func,
    restaurantName: PropTypes.string,
};

export default ManagePhotosContainer;
